export default __webpack_public_path__ + "static/media/sigma-intro.c5db42d3.mp3";